import { IonContent,IonPage } from '@ionic/react';
import Ae2Header from '../../components/AE2/Ae2Header';



import './Homepage.css'
import SuccessStories from '../../components/AE2/AdminSection/SuccessStories';
import AlphaInsightsHeader from '../../components/AE2/AlphaInsightsHeader';



const AE2SuccessStories: React.FC = () => {


  return (
    <IonPage className='ae2-home' >
      <AlphaInsightsHeader/>

      <IonContent className='main-bg'>
        <SuccessStories/>
      </IonContent>
    </IonPage>
  );
};

export default AE2SuccessStories;
